(function() {
    angular
        .module("app")
        .controller("SetUnitModalController", SetUnitModalController)

    SetUnitModalController.$inject = [
        "$scope",
        "$uibModalInstance",
        "messageBoardID",
        "speedLimitTrailersService",
        "selectedUnits",
        "currentSpeed",
        "currentBeaconState",
        "currentWhiteOnBlack",
        "setSuccess",
        "setFailure"
    ]

    function SetUnitModalController(
        $scope,
        $uibModalInstance,
        messageBoardID,
        speedLimitTrailersService,
        selectedUnits,
        currentSpeed,
        currentBeaconState,
        currentWhiteOnBlack,
        setSuccess,
        setFailure
    ){
        "use strict"

        $scope.displayMPHCaution = false

        if (selectedUnits === "MPH" && currentSpeed > 85) {
            currentSpeed = 85
            $scope.displayMPHCaution = true
        }

        $scope.setUnitsMessage = function( ) {

            let speedValue = {
                speed:          currentSpeed,
                units:          selectedUnits,
                white_on_black: currentWhiteOnBlack,
                beacons:        currentBeaconState
            }

            $uibModalInstance.close(
                speedLimitTrailersService.setSpeedDisplay(messageBoardID, speedValue, setSuccess, setFailure)
            )
        }

       $scope.cancel = function() {
            $uibModalInstance.close("cancel")
        }
    }
})()
